import { useState, useEffect } from 'react';
import { Link, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import SvgIcon from '@material-ui/core/SvgIcon';
// import MenuIcon from '@material-ui/icons/Menu';
// import Drawer from '@material-ui/core/Drawer';
// import List from '@material-ui/core/List';
// import Divider from '@material-ui/core/Divider';
// import ListItem from '@material-ui/core/ListItem';
// import ListItemIcon from '@material-ui/core/ListItemIcon';
// import ListItemText from '@material-ui/core/ListItemText';
// import InsertChartIcon from '@material-ui/icons/InsertChart';
// import LocalShippingIcon from '@material-ui/icons/LocalShipping';
// import PeopleIcon from '@material-ui/icons/People';
// import BallotIcon from '@material-ui/icons/Ballot';
// import DashboardIcon from '@material-ui/icons/Dashboard';
// import TrackChangesIcon from '@material-ui/icons/TrackChanges';
// import AssignmentIcon from '@material-ui/icons/Assignment';
import SearchIcon from '@material-ui/icons/Search';
// import GavelIcon from '@material-ui/icons/Gavel';
import { fade } from '@material-ui/core/styles/colorManipulator';

import Company from 'components/company.js';
import SearchBar from './searchbar.js';
import Util from 'lib/util.js';

// const purchsRoutes = [
//   {
//     text: '供应商管理',
//     path: '/mp/purchase/supplier/list',
//     icon: <PeopleIcon />
//   },
//   { text: '采购订单', path: '/mp/purchase/order/list', icon: <BallotIcon /> },
//   {
//     text: '采购变更',
//     path: '/mp/purchase/change/list',
//     icon: <AssignmentIcon />
//   },
//   {
//     text: '送货通知',
//     path: '/mp/purchase/vendorDelivery/list',
//     icon: <LocalShippingIcon />
//   },
//   {
//     text: '采购分析报表',
//     path: '/mp/statistics/purchase/order',
//     icon: <InsertChartIcon />
//   },
//   {
//     text: '物料询价招标',
//     path: '/mp/purchase/inquiry/prod/list',
//     icon: <TrackChangesIcon />
//   },
//   {
//     text: '供应商竞价',
//     path: '/mp/purchase/inquiry/bid/list',
//     icon: <GavelIcon />
//   },
//   {
//     text: '供应商多物料竞价',
//     path: '/mp/purchase/inquiry/bid-multi/list',
//     icon: <GavelIcon />
//   }
// ];

// const saleRoutes = [
//   {
//     text: '客户订单',
//     path: '/mp/sale/customer/order/list',
//     icon: <BallotIcon />
//   },
//   {
//     text: '客户变更',
//     path: '/mp/sale/customer/change/list',
//     icon: <AssignmentIcon />
//   },
//   {
//     text: '送货通知',
//     path: '/mp/sale/delivery/list',
//     icon: <LocalShippingIcon />
//   },
//   {
//     text: '客户物料询价招标',
//     path: '/mp/sale/inquiry/prod/list',
//     icon: <TrackChangesIcon />
//   },
//   { text: '客户竞价', path: '/mp/sale/inquiry/bid/list', icon: <GavelIcon /> },
//   {
//     text: '客户多物料竞价',
//     path: '/mp/sale/inquiry/bid-multi/list',
//     icon: <GavelIcon />
//   }
// ];

const styles = theme => ({
  root: {
    flexGrow: 1
  },
  // menuButton: {
  //   marginLeft: -12,
  //   marginRight: 0,
  // },
  companyWrap: {
    width: 240
  },
  search: {
    width: '100%',
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade('#fff', 0.15),
    marginLeft: 0,
    overflow: 'hidden'
  },
  inputRoot: {
    color: 'inherit',
    paddingTop: 2,
    paddingRight: 6,
    paddingBottom: 2,
    paddingLeft: 50,
    transition: theme.transitions.create('width'),
    width: '100%'
  },
  searchIcon: {
    width: 30,
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  grow: {
    flexGrow: 1
  },
  wrap: {
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    flexGrow: 1
  },
  cancel: {
    width: 35,
    fontSize: 14,
    marginLeft: 15
  },
  home: {
    width: 24,
    height: 24,
    color: '#222222'
  }
});

function TopNav(props) {
  const { classes, inited, isRedirct, defaultValue } = props;
  const [redirect, setRedirect] = useState(null);
  // const [showMenu, setShowMenu] = useState(false);
  const [showSearch, setShowSearch] = useState(false);

  useEffect(() => {
    //如果有搜索值，显示搜索框
    if (!Util.isEmpty(defaultValue)) {
      setShowSearch(true);
    }
  }, [defaultValue]);

  function handleCompanyChange() {
    setRedirect('/mp/workbench');
  }

  function toggleSearch(isShow) {
    setShowSearch(isShow);
    if (!isShow && props.onCancel) {
      props.onCancel();
    }
  }

  // const sideList = (
  //   <div className={classes.list}>
  //     <ListItem button component="a" key="/mp/workbench" href="/mp/workbench">
  //       <ListItemIcon>
  //         <DashboardIcon />
  //       </ListItemIcon>
  //       <ListItemText primary="协同工作台" />
  //     </ListItem>
  //     <Divider />
  //     <List>
  //       {purchsRoutes.map((route, index) => (
  //         <ListItem button component="a" key={route.text} href={route.path}>
  //           <ListItemIcon>{route.icon}</ListItemIcon>
  //           <ListItemText primary={route.text} />
  //         </ListItem>
  //       ))}
  //     </List>
  //     <Divider />
  //     <List>
  //       {saleRoutes.map((route, index) => (
  //         <ListItem button component="a" key={route.text} href={route.path}>
  //           <ListItemIcon>{route.icon}</ListItemIcon>
  //           <ListItemText primary={route.text} />
  //         </ListItem>
  //       ))}
  //     </List>
  //   </div>
  // );

  const searchStyle = {
    root: {
      border: 0
    },
    searchIcon: { opacity: 1 },
    clearIcon: { opacity: 1 }
  };

  if (redirect !== null && isRedirct !== false) {
    return <Redirect to={redirect} />;
  }

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Toolbar>
          <div
            className={classes.wrap}
            style={{ display: showSearch ? 'none' : 'flex' }}
          >
            {/* <IconButton
              style={{ display: showSearch ? 'none' : 'block' }}
              className={classes.menuButton}
              color="inherit"
              aria-label="Menu"
              onClick={() => {
                setShowMenu(true);
              }}
            >
              <MenuIcon />
            </IconButton> */}
            {inited && (
              <IconButton
                style={{ display: showSearch ? 'none' : 'block' }}
                color="inherit"
                aria-label="Home"
              >
                <Link to="/mp/workbench" className={classes.home}>
                  {/* HomeIcon */}
                  <SvgIcon>
                    <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
                  </SvgIcon>
                </Link>
              </IconButton>
            )}
            {inited && (
              <div className={classes.companyWrap}>
                <Company
                  searchBarPlaceholder=""
                  onChange={handleCompanyChange}
                ></Company>
              </div>
            )}
            <div className={classes.grow}></div>
            {props.onSubmit && (
              <div
                className={classes.searchIcon}
                onClick={() => {
                  toggleSearch(true);
                }}
              >
                <SearchIcon />
              </div>
            )}
          </div>

          {showSearch && (
            <div className={classes.wrap}>
              <div className={classes.search}>
                <SearchBar
                  styles={searchStyle}
                  defaultValue={props.defaultValue}
                  focus={true}
                  onChange={props.onChange}
                  onClear={props.onClear}
                  onCancel={props.onCancel}
                  onSubmit={props.onSubmit}
                  placeholder={props.placeholder}
                />
              </div>
              <span
                onClick={() => {
                  toggleSearch(false);
                }}
                className={classes.cancel}
              >
                取消
              </span>
            </div>
          )}
        </Toolbar>
      </AppBar>
      {/* <Drawer
        open={showMenu}
        onClose={() => {
          setShowMenu(false);
        }}
      >
        <div
          tabIndex={0}
          role="button"
          onClick={() => {
            setShowMenu(false);
          }}
          onKeyDown={() => {
            setShowMenu(false);
          }}
        >
          {sideList}
        </div>
      </Drawer> */}
    </div>
  );
}

TopNav.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(TopNav);
